<template>
    <div class="chat-content">
        <div v-for="comment in comments">
        <div class="chat-message self" v-if="userID == comment.id_user_from">
            <div class="chat-message-content-w">
                <div class="chat-message-content">{{comment.body}}</div>
            </div>
            <div class="chat-message-date">{{comment.created_at}}</div>
            <div class="chat-message-avatar"><img alt="" :src="comment.avatar"></div>

        </div>

        <div class="chat-message"  v-else>
            <div class="chat-message-content-w">
                <div class="chat-message-content">{{comment.body}}</div>
            </div>
            <div class="chat-message-avatar"><img alt="" :src="comment.avatar"></div>
            <div class="chat-message-date">{{comment.created_at}}</div>
        </div>
        <!-- <div class="chat-date-separator"><span>Yesterday</span></div> -->
        </div>

    </div>
</template>

<script>
export default {
  props: ['comments'],
  computed: {
    userID () {
      return this.$store.getters.authUser.id_user
    }
  },
  watch: {
    comments () {}
  }
}
</script>

<style>
 .chat-content {
    padding: 20px;
}
 .chat-message {
    margin-bottom: 20px;
}
 .chat-message .chat-message-content {
    padding: 15px 35px;
    background-color: #fff9f0;
    color: #594939;
    max-width: 400px;
    display: inline-block;
    margin-bottom: -20px;
    margin-left: 20px;
    border-radius: 20px;
    text-align: left;
}
 .chat-message .chat-message-avatar {
    display: inline-block;
    vertical-align: bottom;
}
 .chat-message .chat-message-avatar img {
    width: 40px;
    height: auto;
    border-radius: 30px;
    display: inline-block;
    -webkit-box-shadow: 0px 0px 0px 10px #fff;
    box-shadow: 0px 0px 0px 10px #fff;
}
 .chat-message .chat-message-date {
    display: inline-block;
    vertical-align: bottom;
    margin-left: 10px;
    margin-right: 10px;
    font-size: .72rem;
    color: rgba(0,0,0,0.3);
}
 .chat-date-separator {
    text-align: center;
    color: rgba(0,0,0,0.3);
    font-size: .81rem;
    position: relative;
    margin: 20px 0px;
}
 .chat-message.self {
    text-align: right;
}
.chat-message.self .chat-message-content {
    background-color: #f0f9ff;
    color: #2A4E7F;
    margin-right: 20px;
    margin-left: 0px;
}
</style>
